import React from 'react';
import { Control, useFormContext, useWatch } from 'react-hook-form';

interface FormValueProps {
  // valor del campo del formulario a obtener, si no esta presente se obtiene el valor del formulario completo
  field?: string;
  // funcion que retorna un componente al que se le pasa el valor del formulario
  render?: (val: { value: any; errors: any }) => React.ReactNode;
  // control del formulario. Necesario si no se esta usando el contexto del formulario
  control?: Control<any>;
}

/**
 * Componente que obtiene el valor de un campo del formulario dentro del contexto del formulario.
 * Creado para optimizar la renderizacion del campo y no tener que andar re-renderziando componentes enteros.
 * Referencia: https://react-hook-form.com/api/usewatch/
 */
export const FormValue = ({ field, render, control }: FormValueProps) => {
  const currentValue = useWatch({
    defaultValue: '',
    control,
    name: field,
  });
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <React.Fragment>
      {render({
        value: currentValue,
        errors: field ? errors[field] : errors,
      })}
    </React.Fragment>
  );
};
